export default __webpack_public_path__ + "static/media/kalahastiTemple8.861d46bf.png";